
import React, { useState, useEffect } from "react";
import { Button, Modal, Icon, Popup, Grid ,Table } from "semantic-ui-react";
import { getStatementUpdateStatusRequest } from "../../../../../../apiCalls/MainFormRequests";
import moment from 'moment';
let monthMapping = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
}

export default function StatusDetailModal({
  trigger,
   handleModalClose,
   updateModelOpen,
  selectedEntriesCount,
  entryNumber,
  statementNumber,
  filerCode,
  statementPrintDate,
  importerRecordNumber,
  getStatementData,
  toggleModal
}) {

  const [updateStausGridData, setUpdateStatusGridData] = useState([]);

 const [submitLoading , setSubmitLOading] = useState(false)

const convertDateFormat = (date) => {

  if(!date||date==="null") return "";
  let year = date.substring(4);
  let  month = date.substring(0,2);
  let  day = date.substring(2,4);

  

  return `${monthMapping[month]} ${day}, 20${year}`;
}

const paymentTypesDropDownValues = (paymentType) =>{
  let mapping ={
    '1': 'Individual Payment (NOT on a Statement)',
    '2': 'Daily Statement (Broker/Filer)',
    '3': 'Daily Statement (Importer - Full IOR Number)',
    '5': 'Daily Statement (Importer - IOR Number without Suffix)',
    '6': 'Monthly Statement (Broker/Filer)',
    '7': 'Monthly Statement (Importer - Full IOR Number)',
    '8': 'Monthly Statement (Importer - IOR Number without Suffix)',
  }

  return `${paymentType}-${mapping[paymentType]}`;
}

const createLastActionPerformed = (paymentType,date,month ) => {
  let text =""
  if(paymentType === "1" && date === "null" && month === "null"){
    text =  `Changed to ${paymentTypesDropDownValues(paymentType)}`
  }
  else if (paymentType !== "1" && date !== "null" && month === "null"){
     text = `Changed to ${paymentTypesDropDownValues(paymentType)} & pushed to ${convertDateFormat(date)}`
  }
  else if(paymentType !== "1" && date !== "null" && month !== "null"){
    text = `Changed to ${paymentTypesDropDownValues(paymentType)} , pushed statement date to ${convertDateFormat(date)} &  statement month to ${monthMapping[month]}`
  }
  

  return text
}
  useEffect(() => {
if(updateModelOpen === true){
// get data for api to default 

let entryNumberList =[entryNumber]



let getUpdateStatusPayload = {
  statementNumber :statementNumber,
  brokerCode : filerCode,
  entryNumbers : entryNumberList
}

getStatementUpdateStatusRequest(getUpdateStatusPayload).then(async (res)=>{
  console.log(res ,"response from file statement")
  if(res && res.data && res.data.eventMessage && res.data.eventMessage.entries  && res.data.eventMessage.entries.length > 0 ){
    let data = prepareStatusDetailsGrid(res.data.eventMessage.entries)
    setUpdateStatusGridData(data)
  }
});

}

    
      return () => {
        setUpdateStatusGridData([])
     
       
      };
    
 
  }, [updateModelOpen]);

 const prepareStatusDetailsGrid = (data) => {
    let res = data.map(
        (invoiceItem, index) => {
          let newInvoiceItem = {importerRecordNumber : "" , entryNumber :"" , lastModifiedTime : "" , status :"" ,narrativeText :"" }
          newInvoiceItem.importerRecordNumber = importerRecordNumber || "";
          newInvoiceItem.entryNumber = filerCode + '-' + invoiceItem.entryNumber || "";
          newInvoiceItem.lastModifiedTime = midDateFormatter(parseInt(new Date(invoiceItem.lastModifiedTime).getTime())) || "";
          newInvoiceItem.status = invoiceItem.status || "";
          newInvoiceItem.narrativeText = invoiceItem.narrativeText ;     
          newInvoiceItem.isArchivedSuccessfully = invoiceItem.isArchivedSuccessfully; 
          newInvoiceItem.conditionCode = invoiceItem.conditionCode; 
          newInvoiceItem.reason = invoiceItem.reason ;  
          newInvoiceItem.lastActionPerformed = createLastActionPerformed(invoiceItem.paymentType ,invoiceItem.newStatementPrintDate||"null",invoiceItem.periodicStatementMonth||"null"  )
          return newInvoiceItem;
        }
      );
    
      return res;
 }

 const handleAuthorize = async () => {
  toggleModal('');
   setSubmitLOading(true)
  
    await  handleModalClose()

  setSubmitLOading(false)
  toggleModal('pre daily payment service');
}


 function midDateFormatter(seconds) {
    try {
      let time = moment.unix(seconds / 1000).format("MMM Do, YYYY");
      if (time === "Invalid date") return null;
      return time;
    } catch (e) {
      console.error('Error converting epoch', e)
      return ''
    }
  }
  

  return (
    <Modal
      style={{ width: "60%", top: "5%" }}
      trigger={trigger}
      open={updateModelOpen}
      // open={true}
      onClose={handleModalClose}
      dimmer={true}
    >
      <Grid className ="updateStatementGrid">
        <Grid.Row columns={3}>
          <Grid.Column width={7}></Grid.Column>
          <Grid.Column width={2}>
            {/* <img
              className={`qryFuncIcon`}
              // src={qryFuncIcon}
              alt="qry func icon"
            /> */}
          </Grid.Column>
          <Grid.Column width={6}></Grid.Column>
          <Grid.Column width={1}>
            {" "}
            <Icon
              style={{
                position: "relative",

                color: "#008B8F",
                boxSizing: "border-box",
              }}
              name="cancel"
              className="close link icon"
              onClick={() => {
                handleModalClose();
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}> 
         
              <label className="statusDetailsModalmhmeadinmg">{`Update Status`}</label>
              <Popup
                        trigger={
                          <Icon loading={submitLoading} 
                          onClick={() => handleAuthorize()}
                              style={{color: '#007BFF', cursor: 'pointer' ,float :"right"}} size='large' name='redo alternate'/>
                        }
                        content={"Refresh"}
                      />
             
            
         </Grid.Column> 
        </Grid.Row>
       <Grid.Row>
       <Table basic='very' selectable>
                          <Table.Header>
                          <Table.Row>
                          <Table.HeaderCell>IMPORTER</Table.HeaderCell>
                              <Table.HeaderCell>ENTRY #</Table.HeaderCell>
                            
                             
                              <Table.HeaderCell>LAST UPDATED</Table.HeaderCell>
                              <Table.HeaderCell>UPDATE STATUS</Table.HeaderCell>
                              <Table.HeaderCell>LAST ACTION PERFORMED</Table.HeaderCell>
                          </Table.Row>
                          </Table.Header>

                          <Table.Body>
                          { updateStausGridData ? updateStausGridData.map((item, i) => (
                                  <Table.Row style={{cursor: 'pointer'}}>
                                  <Table.Cell>{item.importerRecordNumber}</Table.Cell>
                                  <Table.Cell>{item.entryNumber}</Table.Cell>
                                
                                  <Table.Cell>{item.lastModifiedTime}</Table.Cell>
                                 
                              
                                
                                  <Table.Cell><div style={item.status ==="ACCEPTED" ? {color : "green"} :item.status ==="REJECTED" ? {color :"red"} :{} }>{item.status}</div>
                                  {item.narrativeText !== "null" && <div style={{whiteSpace : "nowrap"}}> {item.narrativeText} {item.conditionCode !== "null" && "("+item.conditionCode+")"} </div>}
                                  {item.status === "ACCEPTED" && <div style={item.isArchivedSuccessfully ==="true" ? {color : "green"} :  item.isArchivedSuccessfully ==="false"? {color :"red"} :{} } > {item.reason}</div>}
                                  </Table.Cell>
                                  <Table.Cell>{item.lastActionPerformed}</Table.Cell>
                             </Table.Row>
                            
         
                              )) : null}
                          </Table.Body>
                        </Table>
                        <hr />
       </Grid.Row>

        <Grid.Row style={{borderTop :"1px solid  #D2D2D2"}}>
          <Grid.Column width={3}>
          <Button
              className="updateBtnSTatementMOdal"
              onClick={() => {
                handleModalClose();
                // setIsUpdateClicked(false);
              }}
            >
              OK
            </Button>
        

          </Grid.Column>

        </Grid.Row>
      </Grid>
    </Modal>
  );
}
